// extracted by mini-css-extract-plugin
export var barContainer = "_56-0";
export var extraThin = "_56-3";
export var fillBar = "_56-6";
export var fillContainer = "_56-4";
export var overflow = "_56-8";
export var overflowContainer = "_56-5";
export var regular = "_56-7";
export var thick = "_56-1";
export var thin = "_56-2";